import { render, staticRenderFns } from "./ProjectCard.vue?vue&type=template&id=50604353&scoped=true"
import script from "./ProjectCard.vue?vue&type=script&lang=js"
export * from "./ProjectCard.vue?vue&type=script&lang=js"
import style0 from "./ProjectCard.vue?vue&type=style&index=0&id=50604353&prod&lang=scss&scoped=true"
import style1 from "./ProjectCard.vue?vue&type=style&index=1&id=50604353&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50604353",
  null
  
)

export default component.exports